<template>
    <footer class="footer g_restrict">
        <footer-socials />
        <button-top v-if="this.$breakpoint.isS" />
        <footer-copyright />
    </footer>
</template>

<script>
import ButtonTop from '@/components/common/ButtonTop'
import FooterCopyright from '@/components/footer/FooterCopyright'
import FooterSocials from '@/components/footer/FooterSocials'

export default {
    name: 'LayoutFooter',
    components: {
        ButtonTop,
        FooterCopyright,
        FooterSocials
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import ~gvue/src/core/Zone/sass/zone/zone

.footer
    color: $color_dark

.g
    .g_restrict
        display: flex
        padding: ($gap * 3.5) 0 ($gap * 1.5)

+mobile
    .g
        .g_restrict
            flex-direction: column
            align-items: center

+desktop
    .g
        .g_restrict
            align-items: center
            justify-content: space-between
            padding: ($gap * 1.5) 0
</style>
